import { useEffect } from "react";

export function useRevealObserver() {
  useEffect(() => {
    document.documentElement.classList.add("is-loaded");
    const targets = document.querySelectorAll(".reveal-on-scroll");
    if (!targets.length) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px" },
    );
    targets.forEach((target) => observer.observe(target));
    return () => observer.disconnect();
  }, []);
}
